import {useEffect} from 'react';

export function useAfterTimeout(cb: () => unknown, timeout?: number) {
    useEffect(() => {
        if (!timeout) return;
        const handle = setTimeout(() => cb(), timeout);
        return () => clearTimeout(handle);
    }, [timeout, cb]);
}
